import Chance from 'chance';

angular.module('cfn').service('seedSuggestionService', seedSuggestionService);

seedSuggestionService.$inject = [
    '$log',
    '$http',
];

export default function seedSuggestionService($log, $http) {

    const chance = new Chance();
    
    let URL = {
        seedSuggestion: '/365FarmNet/mod/crop-planning-service/rest/planning/seed/v1.0/suggest',
        seedService: '/365FarmNet/rest/core/seed/ActiveOnly'
    };

    /**
     * helper method to generate mockdata
     * @param search
     * @returns {{searchString: string, last: boolean, results: Array, totalElements: number}}
     */
    function generateMockData(search) {
        const chance = new Chance();

        let mockResults = {
            results: [],
            searchString: search ? search : '',
            totalElements: 20,
            last: false,
        }

        for (let i = 0; i < 3; i++) {
            const suggestion = {
                id: chance.guid(),
                type: 'SUGGESTION',
                cultureName: chance.word({length: 10}),
                sysCultureId: chance.guid(),
                seedName: chance.word({length: 10}),
                seedId: chance.guid(),
                harvestType: 'MAIN_CROP',
                year: chance.year({min: 2018, max: 2020})
            };

            mockResults.results.push(suggestion);
        }
        return mockResults;
    };


    /**
     * service method to call rest service to get seed suggestions
     * @param search - search string
     * @param fields - array of field ids
     * @param years - array of years
     * @param validLicense - license for planing module?
     * @returns [SeedSuggestion]
     */
    let getSeedSuggestions = function (search, fieldIds, years, validLicense) {

        // return generateMockData(search);

        if (!fieldIds || fieldIds.length === 0 || !years || years.length === 0 || !validLicense) {
            $log.error('Error: unable to query seed suggestions. Missing field ids, years or valid licence.');
            return mapResponse([], search);
        }

        let seedSuggestionRequest = {
            fieldIds: fieldIds,
            years: years
        };

        return $http.post(URL.seedSuggestion, seedSuggestionRequest).then(
            (response) => {
                return mapResponse(response, search);
            },
            (errorResponse) => {
                $log.error('Error: unable to query seed suggestions.', errorResponse);
                return mapResponse(response, search);
            }
        );
    };

    let getSeeds = function (search) {
        return $http.get(URL.seedService).then(
            (response) => {
                return mapResponse(response, search);
            },
            (errorResponse) => {
                $log.error('Error: unable to query user seeds.', errorResponse);
                return mapResponse(response, search);
            }
        );
    };

    function mapResponse(response, search) {
        let mappedResponse = {
            results: [],
            searchString: search ? search : '',
            totalElements: 0,
            last: true,
        };

        if (!response.data || response.data.length === 0) {
            return mappedResponse;
        } else {
            mappedResponse.totalElements = response.data.length;
            mappedResponse.last = response.data.length <= 10 ? true : false;

            // add type seed to support further processing in booking module
            response.data.forEach((item) => {
                item._objectType = 'seed'

                // if item has a year attribute than it is an suggestion
                if (item.year) {
                    item.id = item.seedId + '__' + item.year;
                    delete item.seedId;

                    item.sysSeed_sysCulture_name = item.cultureName;
                    delete item.cultureName;

                    item.name = item.seedName;
                    delete item.seedName;

                    item.sysSeed_sysCulture_abbrFruit = item.cultureAbbreviation;
                    delete item.cultureAbbreviation;

                    item.sysSeed_sysCulture_category = item.category;
                    delete item.category;
                }
                mappedResponse.results.push(item);
            });
            return mappedResponse;
        }
    };

    // Public
    let seedSuggestionService = {
        getSeedSuggestions: getSeedSuggestions,
        getSeeds: getSeeds
    };

    return seedSuggestionService;
}
